module.exports = __webpack_public_path__ + "img/search.2990601f.png";